import React from "react";
import { InfertilityStackScreenProps } from "../InfertilityNavigator";
import { useInfertility } from "../InfertilityContext";
import { transformInfertilityStateToAPI } from "../transformInfertilityState";
import { usePatient } from "@louise/patients/hooks/usePatient";
import { useQueuedPatientUpdate } from "@louise/patients/sync/usePatientSync";
import {
  BaseCompleteScreen,
  navigateToNextSection,
  getNextSectionButtonLabel,
} from "@louise/medical-history/components/BaseCompleteScreen";
import { useTranslations } from "@src/packages/i18n";

export function InfertilityCompleteScreen({
  navigation,
}: InfertilityStackScreenProps<"InfertilityComplete">) {
  const t = useTranslations();
  const { state } = useInfertility();
  const { data: patient } = usePatient();
  const { mutateAsync: updatePatient, isPending: isUpdatingPatient } =
    useQueuedPatientUpdate();

  const handleFinish = async () => {
    try {
      // Transform state to API format (pass patient to track deletions)
      const payload = transformInfertilityStateToAPI(
        state,
        state.partnerCause,
        state.partnerComments,
        patient,
      );

      await updatePatient(payload);

      navigateToNextSection(navigation, "infertility");
    } catch {}
  };

  return (
    <BaseCompleteScreen
      subtitle={t("med_history.fertility.infertility.complete_subtitle")}
      buttonLabel={getNextSectionButtonLabel(t, "infertility")}
      isSubmitting={isUpdatingPatient}
      onFinish={handleFinish}
    />
  );
}

export default InfertilityCompleteScreen;
